import React, { useState } from "react";

import { Container, CheckboxSquare, Label } from "./styles";

//Interface
import { CheckboxPropsInterface } from "./intefaces";

//Assets
import check from "../../assets/icons/check.svg";

const Checkbox = (props: CheckboxPropsInterface) => {
    // const [isChecked, setIsChecked] = useState(false);

    return(
        <Container>
            <CheckboxSquare isChecked={props.isChecked} onClick={props.onClick}>
                {props.isChecked ? <img src={check} alt="V"/> : null}
            </CheckboxSquare>
            <Label>{props.label ? props.label : props.isChecked ? "Sim" : "Não"}</Label>
        </Container>
    )
}

export default Checkbox;